var App;

App = require('config/app');

module.exports = App.DocumentsNewRoute = App.DocumentRoute.extend({
  activate: function() {
    return document.title = 'New Document - Poe';
  },
  renderTemplate: function() {
    return this.render('document');
  },
  setupController: function(controller, model) {
    this.controllerFor('document').set('content', model);
    return this.controllerFor('document').set('isCreating', true);
  },
  model: function() {
    var now;
    now = new Date();
    return this.store.createRecord('document', {
      title: 'Untitled.md',
      body: 'Content goes here...',
      createdAt: now,
      updatedAt: now
    });
  },
  actions: {
    save: function() {
      var _this = this;
      return this.modelFor('documents.new').save().then(function() {
        _this.controllerFor('document').set('isCreating', false);
        return _this.transitionTo('documents');
      });
    },
    cancelNewRecord: function(record) {
      record.deleteRecord();
      this.controllerFor('document').set('isCreating', false);
      return this.transitionTo('documents');
    }
  }
});
